<ng-container *ngFor="let chip of selectableItems; trackBy: chipsTracker">
  <div class="chips"
    [ngClass]="{'selected': chip?.isSelected}"
    (click)="toggleSelection(chip.tempId)"
    >{{chip.label}}</div>
</ng-container>
